import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { http, formatApiError } from "@/lib/api";

const Confirm = ({ trigger, title, description, onConfirm, testId }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
    <AlertDialogContent className="border-white/10 bg-[#141C2E] text-slate-100">
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription className="text-slate-400">{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="border-white/10 bg-transparent text-slate-300">Cancelar</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} className="bg-red-600 text-white hover:bg-red-500" data-testid={testId}>Excluir</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const BulkDeleteBar = ({ selected, total, onDone }) => {
  const run = async (body) => {
    try {
      const { data } = await http.post("/admin/requests/bulk-delete", body);
      toast.success(`${data.deleted} solicitação(ões) excluída(s).`);
      onDone();
    } catch (e) { toast.error(formatApiError(e)); }
  };
  const warn = "Solicitações, pontuações, agendamentos, observações e histórico serão removidos definitivamente. A ação fica registrada na auditoria.";
  return (
    <div className="flex flex-wrap gap-2" data-testid="bulk-delete-bar">
      <Confirm testId="bulk-delete-selected-confirm" title={`Excluir ${selected.length} solicitação(ões) selecionada(s)?`} description={warn} onConfirm={() => run({ ids: selected })}
        trigger={<button disabled={!selected.length} className="btn-ghost-sm text-red-300 disabled:opacity-40" data-testid="bulk-delete-selected-btn"><Trash2 className="h-3.5 w-3.5" /> Excluir selecionadas ({selected.length})</button>} />
      <Confirm testId="bulk-delete-all-confirm" title={`Excluir TODAS as ${total} solicitações?`} description={warn} onConfirm={() => run({ all: true })}
        trigger={<button disabled={!total} className="btn-ghost-sm text-red-300 disabled:opacity-40" data-testid="bulk-delete-all-btn"><Trash2 className="h-3.5 w-3.5" /> Excluir todas</button>} />
    </div>
  );
};
